import { render, staticRenderFns } from "./ChangePasswordDialog.vue?vue&type=template&id=2de55f5b&scoped=true&"
import script from "./ChangePasswordDialog.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de55f5b",
  null
  
)

export default component.exports